import { createRoot } from 'react-dom/client';
import { Buffer } from 'buffer';
import { inject } from '@vercel/analytics';
import { SpeedInsights } from '@vercel/speed-insights/react';
import App from './App.tsx';
import './index.css';
import './utils/pdfFonts';
import { initSentry } from "./sentry";

// Ensure Buffer is available globally for libraries like @react-pdf/renderer
// that expect a Node-style Buffer in the browser (including worker contexts).
(window as any).Buffer = Buffer;

initSentry();

// Initialize Vercel Web Analytics
inject();

if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker
      .register('/service-worker.js')
      .catch(() => {
        // Ignore service worker registration errors
      });
  });
}

createRoot(document.getElementById('root')!).render(
  <App />
);
